import { useMediaQueries } from "#src/utils/useMediaQueries.tsx";
import { useEffect, useState } from "react";

export function useMainOffset() {
  const [offsetTop, setOffsetTop] = useState(50);
  const queries = useMediaQueries();

  function getOffset() {
    const main = document.getElementById("main");

    if (main) {
      const style = getComputedStyle(main);
      const offset = parseInt(style.marginTop);

      setOffsetTop(offset);
    }
  }

  useEffect(() => {
    getOffset();
  }, []);

  useEffect(() => {
    getOffset();
  }, [queries]);

  return offsetTop;
}
